import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { memo, useCallback, useMemo } from 'react';
import { FactionIdToName } from '../utils.js';
import useStyles from './System.styles.js';
import { useWarzoneSystemStatus } from '../context/warzone-status.js';
import { useWarzoneMapSystem } from '../context/warzone-map.js';
var System = memo(function (_ref) {
  var solarsystemId = _ref.solarsystemId,
    classNames = _ref.classNames,
    styles = _ref.styles,
    unstyled = _ref.unstyled,
    onClick = _ref.onClick;
  var _useWarzoneMapSystem = useWarzoneMapSystem(solarsystemId),
    data = _useWarzoneMapSystem.data,
    adjacency = _useWarzoneMapSystem.adjacency,
    type = _useWarzoneMapSystem.type,
    isSelected = _useWarzoneMapSystem.isSelected;
  var _useWarzoneSystemStat = useWarzoneSystemStatus(solarsystemId),
    status = _useWarzoneSystemStat.status,
    active = _useWarzoneSystemStat.active,
    loading = _useWarzoneSystemStat.loading;
  var clickHandler = useCallback(function (event) {
    if (onClick) onClick(_objectSpread(_objectSpread({}, event), {}, {
      data: solarsystemId
    }));
  }, [onClick, solarsystemId]);
  var _useStyles = useStyles(void 0, {
      name: "WarzoneMapSystem",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return useMemo(function () {
    var _a;
    if (type !== "system") return /* @__PURE__ */jsx(Fragment, {});
    var adjacencyClass = classes[adjacency];
    var factionClass = status !== void 0 && !loading ? classes[(_a = FactionIdToName(status.occupierFaction)) != null ? _a : "neutral"] : "";
    return /* @__PURE__ */jsxs("g", {
      id: "system-".concat(solarsystemId),
      className: cx(classes.systemTransitions, isSelected ? classes.selectedSystem : ""),
      children: [/* @__PURE__ */jsx("path", {
        d: data.polygon,
        className: cx(active ? classes.activeSystem : classes.passiveSystem, adjacencyClass, factionClass, classes.fill, classes.fillFilter),
        onClick: clickHandler,
        filter: "url(#fill-filter)",
        children: /* @__PURE__ */jsx("title", {
          children: data.name
        })
      }, "fill"), /* @__PURE__ */jsx("path", {
        d: data.polygon,
        className: cx(adjacencyClass, factionClass, classes.border),
        filter: "url(#border-filter)"
      }, "border")]
    });
  }, [type, status, classes, cx, active, adjacency, data, solarsystemId, clickHandler, loading, isSelected]);
});
System.displayName = "WarzoneMapSystem";
export { System };